import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';
import { useContactSync } from './useContactSync';

// Desktop "Phone contacts" card on the Profile page. Reading a phone book needs
// the Android app; from a desktop the user can see the status and delete.
export default function ContactSyncDesktop({ user }) {
  const vm = useContactSync(user);
  const { canSync, status, consentOpen, syncing, progress, deleting, disclosure, askConsent, decline, agreeAndSync, deleteAll } = vm;
  const has = (status?.contacts || 0) > 0;

  return (
    <div className="card card-pad" style={{ maxWidth: 520, marginTop: 12 }}>
      <strong>Phone contacts</strong>
      <div className="muted" style={{ fontSize: 13, margin: '4px 0 10px' }}>
        {has
          ? `${status.contacts} contacts (${status.numbers} numbers) saved${status.syncedDate ? ` · last sync ${fmtDateTime(status.syncedDate)}` : ''}. They help you find people when adding guests.`
          : 'Not synced. Syncing your phone book lets you find people by name when adding guests.'}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {canSync ? (
          <button className="btn primary sm" onClick={askConsent} disabled={syncing}>
            {syncing ? `Syncing ${progress.done}/${progress.total}…` : has ? 'Sync again' : 'Sync my contacts'}
          </button>
        ) : (
          <span className="muted" style={{ fontSize: 12 }}>📱 Syncing is done from the Mehfil Android app.</span>
        )}
        {has && <button className="btn danger sm" onClick={deleteAll} disabled={deleting}>{deleting ? 'Deleting…' : 'Delete synced contacts'}</button>}
      </div>
      {consentOpen && (
        <Modal title="Upload your contacts?" onClose={decline}
          footer={<><button className="btn light" onClick={decline}>No thanks</button><button className="btn primary" data-save="off" onClick={agreeAndSync}>Agree &amp; sync</button></>}>
          {disclosure.map((t, i) => <p key={i} style={{ marginTop: 0 }}>{t}</p>)}
        </Modal>
      )}
    </div>
  );
}
